module.exports = __webpack_public_path__ + "static/media/menu-background.27e9335d.png";